import { render, staticRenderFns } from "./tds.vue?vue&type=template&id=7cbfb26a"
import script from "./tds.vue?vue&type=script&lang=js"
export * from "./tds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports